import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InvestorQualification from '../InvestorQualification';

const IndependentQualification = ({ issuerConfig }) => (
  <InvestorQualification onSubmitSuccess={() => window.location.href = `${issuerConfig.securitizeIdUrl}/wallets`} />
);

IndependentQualification.propTypes = {
  issuerConfig: PropTypes.objectOf(PropTypes.any),
};

IndependentQualification.defaultProps = {
  issuerConfig: {},
};

const mapStateToProps = ({ issuerConfiguration }) => ({
  issuerConfig: issuerConfiguration.config,
});

export default connect(mapStateToProps, null)(IndependentQualification);
